"use client"
import React, { useEffect, useState} from 'react';
import { Form, Formik } from 'formik';
import _ from 'lodash';
import OrderSummery from '@/comman/OrderSummery';
import { CreateObject } from '@/services/Methods/checkoutPayloads';
import ButtonComponent from '@/Inputs/ButtonComponent';
import { ContextData, MiniLoader, cn, storeAssigned,_scrollToUp } from '@/services/Methods/normalMethods';
import withCheckoutHOC from '@/HOC/withCheckoutHOC';
import { _formDefaultFormat } from '@/services/Methods/validationSchema';
import { MainCheckOutStyle } from '@/styles/CheckoutSection.style';
import SuggestionAddressPopup from '@/comman/SuggestionAddressPopup';
import CheckoutStepOne from '@/components/checkoutSteps/components/CheckoutStepOne';
import CheckoutStepTwo from '@/components/checkoutSteps/components/CheckoutStepTwo';
import CheckoutStepThree from '@/components/checkoutSteps/components/CheckoutStepThree';
import CheckoutStepFour from '@/components/checkoutSteps/components/CheckoutStepFour';
import CheckoutStepFive from '@/components/checkoutSteps/components/CheckoutStepFive';
import CheckoutStepSix from '@/components/checkoutSteps/components/CheckoutStepSix';
import CheckoutValidationSchema from '@/components/checkoutSteps/CheckoutValidationSchema';
import AddressErrorPopup from '@/components/checkoutSteps/components/AddressErrorPopUp';
import Loader from '@/comman/Loader';
import UseCreateAccountHook from '../../../hooks/CreateAccount.hooks';
import localStorageCall from '@/services/Methods/localstorage.hook';
import withProductHOC from '@/HOC/withProductHOC';
import ReferralPopup from '@/comman/ReferralPopup';
import DialogComponent from '@/Inputs/DailogComponent';
import { DialogActions } from '@mui/material';
import LoaderComponent from '@/Inputs/LoaderComponent';
import { useFormikContext } from 'formik';


const CheckoutSection = (props) => {
    const {
        formData, calculatedData, isUserLogin, isLoading, useDefaultAddressOrNot, normalAddressError, fetchUserDataLoading, referralerror, AUTOSHIP_PRODUCTS_ON_CART, paymentError,

        PRODUCTS_ON_CART, rankUpgrad, section, addToCartProducts, usePoint, customerSliceError,
        _acceptOrNotAddressOption, calculateApiLoading, loginSliceloading, customerSliceLoading, CURRUNT_ROLE,
        setSmartSaveSchedule, smartSaveSchedule, subTotal, checkValidUser, orders, selectedCategory, checkoutProccessing,
        pathname, _handleDLocalPopup, askPopupDLocal, paymentOption_ID, selectedLanguage, setSelectedLanguage, scriptError, SINGLE_MEMBERSHIPCHECK, userData,
        loginErrorMsg,_webAliesCheckDuringSubmit,webAliesError, setWebAliesErros
    } = props;
    const comingFrom = 'normal'
    let Status = false;

    const PARENTS_PRODUCT_CALCULATE = _.filter(calculatedData?.oneTimeCalculateData?.details, (value) => value?.parentItemId === null);
    const PARENTS_PRODUCT_AUTOSHIP = _.filter(calculatedData?.autoshipCalculateData?.details, (value) => value?.parentItemId === null);
    const PARENTS_PRODUCT_MEMBER = _.filter(calculatedData?.membershipCalculateData?.details, (value) => value?.parentItemId === null);

    const NORMAL_PRODUCTS = _.map(PARENTS_PRODUCT_CALCULATE, (row) => {
        const values = CreateObject(row);
        return ({
            ...values, subProducts: _.map(_.filter(calculatedData?.details, (r) => r?.parentItemId === row?.itemId), (v) => CreateObject(v))
            , autoship: "oneTime"
        });
    });

    const createAccountData = UseCreateAccountHook();

    useEffect(() => {
        const REFFERAL_LINK = localStorageCall().getItem("refferal_link");
        if (REFFERAL_LINK) {
            createAccountData?.setOpenPopup(false);
        } else {
            createAccountData?.setOpenPopup(true);
        }
    }, [pathname])

    const condition = (process.env.NEXT_PUBLIC_OTP_SECTION === "true") ? checkValidUser : true;

    const isCbd = addToCartProducts['normalProducts']?.filter(key => key.category_id === 1009)

    const AUTOSHIP_PRODUCTS = _.map(PARENTS_PRODUCT_AUTOSHIP, (row) => {
        const values = CreateObject(row);
        return ({
            ...values, subProducts: _.map(_.filter(calculatedData?.details, (r) => r?.parentItemId === row?.itemId), (v) => CreateObject(v)),
            autoship: "autoship"
        })
    });

    const MEMBER_PRODUCTS = _.map(PARENTS_PRODUCT_MEMBER, (row) => {
        const values = CreateObject(row);
        return ({
            ...values, subProducts: _.map(_.filter(calculatedData?.details, (r) => r?.parentItemId === row?.itemId), (v) => CreateObject(v))
            , autoship: "oneTime"
        });
    });

    const AvailableFrequency = localStorage.getItem("deliveryFrequency");
    const AvailableToday = addToCartProducts?.normalProducts;

    const FocusError = () => {
        const { errors, isSubmitting, isValidating } = useFormikContext();

        useEffect(() => {
            if (isSubmitting && !isValidating) {
                let keys = Object.keys(errors);
                if (keys.length > 0) {
                    const selector = `[name=${keys[0]}]`;
                    const errorElement = document.querySelector(selector);
                    if (errorElement) {
                        errorElement.focus();
                    }
                }
            }
        }, [errors, isSubmitting, isValidating]);

        return null;
    };
    const isJapan = _.upperCase(storeAssigned()) === 'JP';

    const europenCountriesAndafricanCountries = [
        "eu", "mt", "cy", "be", "de", "pl", "ro", "si", "it", "es", "at", "se",
        "ie", "fi", "cz", "ru", "sk", "lt", "lv", "pt", "gr", "hu", "dk", "hr",
        "no", "is", "nl", "nc", "re", "bg", "fr", "gb", "rs", "lu", "ch", "ee",
        "dz", "ao", "bj", "bw", "bf", "bi", "cv", "cm", "cf", "td", "km", "cg",
        "cd", "dj", "eg", "gq", "er", "sz", "et", "ga", "gm", "gh", "gn", "gw",
        "ci", "ke", "ls", "lr", "ly", "mg", "mw", "ml", "mr", "mu", "ma", "mz",
        "na", "ne", "ng", "rw", "st", "sn", "sc", "sl", "so", "za", "ss", "sd",
        "tz", "tg", "tn", "ug", "zm", "zw"
    ];

        const fieldValue = useFormikContext();
    
    const [webAliasInput, setWebAliasInput] = useState(() =>
        fieldValue?.values?.webAlias || userData?.webAlias || ''
      );
      
      useEffect(() => {
        if (webAliasInput && fieldValue?.setFieldValue) {
          fieldValue.setFieldValue('webAlias', webAliasInput);
        }
      }, [webAliasInput]);

    return (
        <>
            <MainCheckOutStyle>
                <div className='relative'>
                    {(checkoutProccessing || fetchUserDataLoading || isLoading || customerSliceLoading || loginSliceloading) && <LoaderComponent />}
                    <div className='checkout-main relative after:content-[""] after:absolute after:top-0 after:right-0'>
                        <div className="container md:py-[56px] py-[20px] xl:max-w-[1170px] mx-auto">
                            <div className='modal-border text-center pb-[15px]'>
                                <h3 className='text-center py-3 futura_font uppercase'>Checkout</h3>
                            </div>
                            <div className="">

                                <div className={cn(`content flex lg:flex-nowrap flex-wrap min-h-[561px] gap-[30px]`, 'formContent', { 'flex': (props?.currentStep < 4) })}>
                                    <div className='stepSection w-full lg:w-[60%] border-solid border rounded border-[rgba(0,0,0,.125)] py-[18px] px-[22px]'>
                                        {!isUserLogin && <div className='futura_font mb-1 text-start text-[14px] text-[#444] tracking-[3px]'>Create Account -  <a className='cursor-pointer anchor-clr hover:text-button-hover-color transition-all ease-in-out duration-300 text-[11.5px]' onClick={() => { window.location.assign(`${process.env.NEXT_PUBLIC_ABO_URL}`); }}>Already have an account? Login</a></div>}
                                        <div className="max-w-[100%] lg:ml-auto lg:mr-0 mx-auto 2xl:py-[30px] py-[20px]">
                                            <Formik
                                                enableReinitialize
                                                validationSchema={CheckoutValidationSchema(isUserLogin, {
                                                    autoship: false,
                                                    age: false,
                                                    distributorSignup: section === 'distributorCheckout',
                                                    singleMemberShip: false,
                                                    webAlias: rankUpgrad === "main_enrollment" && (!webAliasInput) ? true : false,
                                                    webAliase: rankUpgrad === "main_enrollment" ? true : false,
                                                    taxType: rankUpgrad === "main_enrollment" && (storeAssigned() === 'co' || storeAssigned() === 'mx') ? true : false,
                                                    taxId: rankUpgrad === "main_enrollment" && (storeAssigned() === 'co' || storeAssigned() === 'mx') ? true : false,
                                                    gNumber: SINGLE_MEMBERSHIPCHECK && isJapan ? true : false,
                                                    gNumberTerms: SINGLE_MEMBERSHIPCHECK && isJapan ? true : false,
                                                    ambtermscondition: SINGLE_MEMBERSHIPCHECK && !europenCountriesAndafricanCountries.includes(storeAssigned()) ? true : false,
                                                    jpStudentTerms: SINGLE_MEMBERSHIPCHECK && isJapan ? true : false,
                                                    // jpAgeTerms: SINGLE_MEMBERSHIPCHECK && isJapan ? true : false,
                                                    jpCitizen: SINGLE_MEMBERSHIPCHECK && isJapan ? true : false,
                                                    country: _.upperCase(storeAssigned()) || 'US',
                                                    isDob: rankUpgrad === "main_enrollment" ? true : false,
                                                    isAmbassador: SINGLE_MEMBERSHIPCHECK ? true : false
                                                })}
                                                validateOnChange={false}
                                                validateOnBlur={false}
                                                initialValues={{
                                                    ...formData, webAlias: webAliasInput || userData?.webAlias || '', termscondition: orders.length < 1 ? false : true, ageCheck: isCbd.length > 0 || orders.length < 1 ? false : true,
                                                    termscondition1: true, ambtermscondition: false, promotions: false,
                                                    gNumberTerms: false, jpStudentTerms: false, jpAgeTerms: false, jpCitizen: '',
                                                }}
                                                onSubmit={(values, actions, error) => {
                                                      // Check the error message string inside the object
                                                      const errorMessages = [
                                                        "Web Alias is already",
                                                        "3 characters long",
                                                        "contain the word"
                                                            ];

                                                            if (webAliesError?.isWebAliesError && errorMessages.some(msg => webAliesError.isWebAliesError.includes(msg))) {
                                                        actions.setSubmitting(false);
                                                        // console.log("webAliasRef.currentwebAliasRef.current",webAliasRef.current);

                                                        const el = document.getElementById("webAlias"); // or use ref.current

                                                        if (el) {
                                                            el.focus();
                                                            el.scrollIntoView({
                                                                behavior: 'smooth',
                                                                block: 'center'
                                                            });
                                                        }
                                                       
                                                    } else {
                                                        props?._handleFormSubmit(values, actions, error);
                                                    }
                                                }}
                                            >
                                                {(fieldValue) => (
                                                    <Form className='common-formcss'>
                                                        <FocusError />
                                                        {/* {!isUserLogin && */}
                                                        <CheckoutStepTwo {...{ isUserLogin, ...props }} />
                                                        <CheckoutStepOne {...{ ...props, isUserLogin, rankUpgrad,_webAliesCheckDuringSubmit ,webAliasInput, setWebAliasInput, setWebAliesErros }} />
                                                        <CheckoutStepThree {...props} />
                                                        <CheckoutStepFour {...props} />
                                                        {(condition) &&
                                                            <>
                                                                <CheckoutStepFive {...{ Status, ...props }} />
                                                                <CheckoutStepSix {...{ ...props, isCbd, AUTOSHIP_PRODUCTS }} />
                                                            </>
                                                        }
                                                        {(scriptError || customerSliceError || props?.error || paymentError) && <p className="text-sm text-red-500 mt-2">{(scriptError || customerSliceError || props?.error || paymentError)}</p>}
                                                        {(condition && !checkoutProccessing) &&
                                                            <div className='text-center flex flex-col items-center mt-[38px]'>
                                                                <ButtonComponent
                                                                    disabled={calculateApiLoading || checkoutProccessing || normalAddressError || props?.error || paymentError}
                                                                    classes="
                                                            w-full xl:mb-1.5 md:mb-1.5 
                                                            2xl:pt-[13px] xl:pt-[11px] pt-[10px] 2xl:pb-[12px] xl:pb-[10px] pb-[9px] 
                                                            px-[20px] text-white rounded-[6px] border-black 2xl:text-[20px] 
                                                            xl:text-[19px] text-[18px] font-medium bg-[#000000] hover:border-[#000000] hover:bg-white 
                                                            hover:text-[#000000]"
                                                                    type="submit">
                                                                    {isLoading || calculateApiLoading || customerSliceLoading
                                                                        ?
                                                                        <MiniLoader />
                                                                        :
                                                                        'PLACE MY ORDER'
                                                                    }
                                                                </ButtonComponent>
                                                            </div>
                                                        }

                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                    <div className='mainorder_summery w-full lg:w-[40%] 2xl:px-[40px] lg:px-[30px] px-[15px] 2xl:py-[55px] py-[40px] pack-bg'>
                                        <div className="sticky-wrap max-w-[100%] lg:mx-0 mx-auto" style={{ position: 'sticky', top: '100px' }}>
                                            {
                                                (!AvailableFrequency || AvailableToday.some(product => product.frequency === "oneTime")) &&
                                                // NORMAL_PRODUCTS?.length > 0 &&
                                                (
                                                    <OrderSummery
                                                        usePoint={props?.usePoint}
                                                        subTotal={subTotal}
                                                        addToCartProducts={addToCartProducts}
                                                        setSmartSaveSchedule={setSmartSaveSchedule}
                                                        smartSaveSchedule={smartSaveSchedule}
                                                        calculate={calculatedData?.oneTimeCalculateData}
                                                        cartData={NORMAL_PRODUCTS?.length > 0 ? NORMAL_PRODUCTS : PRODUCTS_ON_CART}
                                                        section="Today's"
                                                    />
                                                )
                                            }

                                            {
                                                (MEMBER_PRODUCTS?.length > 0) &&
                                                <OrderSummery
                                                    comingFrom={comingFrom}
                                                    usePoint={props?.usePoint}
                                                    subTotal={subTotal}
                                                    addToCartProducts={addToCartProducts?.[`${comingFrom}Products`]}
                                                    calculate={calculatedData?.membershipCalculateData}
                                                    cartData={MEMBER_PRODUCTS?.length > 0 ? MEMBER_PRODUCTS : PRODUCTS_ON_CART}
                                                    section="member"
                                                />
                                            }
                                            {(AUTOSHIP_PRODUCTS?.length > 0 || AUTOSHIP_PRODUCTS_ON_CART?.length > 0) &&
                                                <OrderSummery
                                                    usePoint={props?.usePoint}
                                                    subTotal={subTotal}
                                                    addToCartProducts={addToCartProducts?.[`${comingFrom}Products`]}
                                                    setSmartSaveSchedule={setSmartSaveSchedule}
                                                    smartSaveSchedule={smartSaveSchedule}
                                                    cartData={AUTOSHIP_PRODUCTS?.length > 0 ? AUTOSHIP_PRODUCTS : AUTOSHIP_PRODUCTS_ON_CART}
                                                    calculate={calculatedData?.autoshipCalculateData}
                                                    section="Subscription"
                                                />
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MainCheckOutStyle >
            <SuggestionAddressPopup {...{
                _acceptOrNotAddressOption,
                bypass: useDefaultAddressOrNot?.bypassOrNot,
                ourAddress: formData,
                addressOptions: useDefaultAddressOrNot?.addessData,
            }} />
            <AddressErrorPopup {...{
                _acceptOrNotAddressOption,
                normalAddressError,
                bypass: useDefaultAddressOrNot?.bypassOrNot,
            }} />
            {/* <ReferralPopup section={'checkout'}  {...createAccountData} /> */}
        </>
    )
}
export default withCheckoutHOC(CheckoutSection);